import React from "react";
import "./Topbar.css";
import MailIcon from "../../../assets/images/client-dashboard/topbar-mail.svg";
import ClockIcon from "../../../assets/images/client-dashboard/topbar-clock.svg";
import TopbarAvatar from "../../../assets/images/client-dashboard/topbar-avatar.png";
const Topbar = () => {
  return (
    <div className="clntdashboard__topbar_wrap">
      <div className="clntdashboard__topbar_left">
        <div className="clntdashboard__topbar_litem">
          <div className="clntdashboard__topbar_litemicn">
            <img src={MailIcon} alt="" />
          </div>
          <div className="clntdashboard__topbar_litemtxt">
            contact@serenetax.com
          </div>
        </div>
        <div className="clntdashboard__topbar_litem">
          <div className="clntdashboard__topbar_litemicn">
            <img src={ClockIcon} alt="" />
          </div>
          <div className="clntdashboard__topbar_litemtxt">
            Office Timings: 9 AM EST to 11 PM EST
          </div>
        </div>
      </div>
      <div className="clntdashboard__topbar_right">
        <div className="clntdashboard__topbar_rtavatarwrap">
          <img src={TopbarAvatar} alt="" />
        </div>
      </div>
    </div>
  );
};

export default Topbar;
